import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getProdutividadeConferente } from '../../../services/conferente';
import '../Conferencia.css';

const STATUS_COLORS: Record<string, string> = {
  pendente: 'status-conferencia-pendente',
  em_andamento: 'status-conferencia-em_andamento',
  parcial: 'status-conferencia-parcial',
  concluida: 'status-conferencia-concluida',
  divergente: 'status-conferencia-divergente',
  cancelada: 'status-conferencia-cancelada'
};

const STATUS_LABELS: Record<string, string> = {
  pendente: 'Pendente',
  em_andamento: 'Em Andamento',
  parcial: 'Parcial',
  concluida: 'Concluída',
  divergente: 'Divergente',
  cancelada: 'Cancelada'
};

const TIPO_LABELS: Record<string, { label: string; color: string }> = {
  pre_carregamento: { label: 'Pré-Carreg.', color: '#e65100' },
  carregamento: { label: 'Carregamento', color: '#1565c0' },
  descarregamento: { label: 'Descarreg.', color: '#2e7d32' }
};

const ConferenciaProdutividadeDetalhe: React.FC = () => {
  const { usuarioId } = useParams<{ usuarioId: string }>();
  const navigate = useNavigate();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [periodo, setPeriodo] = useState('mes');

  const carregarDados = useCallback(async () => {
    if (!usuarioId) return;
    try {
      setLoading(true);
      const result = await getProdutividadeConferente(parseInt(usuarioId), periodo);
      setData(result);
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    } finally {
      setLoading(false);
    }
  }, [usuarioId, periodo]);

  useEffect(() => { carregarDados(); }, [carregarDados]);

  if (loading) {
    return (
      <div className="page-container">
        <div style={{ textAlign: 'center', padding: '100px 20px' }}>
          <div className="loading-spinner-large"></div>
          <p>Carregando...</p>
        </div>
      </div>
    );
  }

  if (!data || !data.conferente) {
    return (
      <div className="page-container">
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#7f8c8d' }}>
          <p>Erro ao carregar dados do conferente</p>
          <button className="btn btn-primary" style={{ marginTop: 12, marginRight: 8 }} onClick={carregarDados}>Tentar novamente</button>
          <button className="btn btn-secondary" style={{ marginTop: 12 }} onClick={() => navigate('/conferencia/produtividade')}>Voltar</button>
        </div>
      </div>
    );
  }

  const { conferente, estatisticas, leituras } = data;
  const sessoes = data.sessoes || [];
  const leituras_por_dia = data.leituras_por_dia || [];
  const ultimas_conferencias = data.ultimas_conferencias || [];

  return (
    <div className="page-container" style={{ maxWidth: 1000, margin: '0 auto' }}>
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button className="conferencia-back-link" onClick={() => navigate('/conferencia/produtividade')} style={{ marginBottom: 0 }}>
            <i className="fas fa-arrow-left"></i>
          </button>
          <div className="conferente-avatar">
            <i className="fas fa-user"></i>
          </div>
          <div>
            <h1 style={{ fontSize: '1.3rem', margin: 0 }}>{conferente.nome}</h1>
            <p style={{ margin: 0, fontSize: '0.85rem', color: '#7f8c8d' }}>{conferente.email}</p>
          </div>
        </div>
        <select className="form-control" value={periodo} onChange={(e) => setPeriodo(e.target.value)} style={{ width: 'auto' }}>
          <option value="dia">Hoje</option>
          <option value="semana">Esta semana</option>
          <option value="mes">Este mês</option>
          <option value="ano">Este ano</option>
        </select>
      </div>

      {/* Cards de estatísticas */}
      <div className="conferencia-stats-grid">
        <div className="conferencia-stat-card">
          <div className="stat-header">
            <i className="fas fa-chart-bar" style={{ color: '#3498db' }}></i>
            <span>Conferências</span>
          </div>
          <p className="stat-value">{estatisticas.total_conferencias}</p>
          <p className="stat-sub" style={{ color: '#27ae60' }}>{estatisticas.concluidas} concluídas</p>
        </div>
        <div className="conferencia-stat-card">
          <div className="stat-header">
            <i className="fas fa-barcode" style={{ color: '#8e44ad' }}></i>
            <span>Leituras</span>
          </div>
          <p className="stat-value">{leituras.total}</p>
          <p className="stat-sub" style={{ color: '#27ae60' }}>{leituras.ok} OK</p>
        </div>
        <div className="conferencia-stat-card">
          <div className="stat-header">
            <i className="fas fa-clock" style={{ color: '#e67e22' }}></i>
            <span>Tempo Médio</span>
          </div>
          <p className="stat-value">{estatisticas.tempo_medio_minutos > 0 ? estatisticas.tempo_medio_minutos : '-'}</p>
          <p className="stat-sub" style={{ color: '#7f8c8d' }}>minutos</p>
        </div>
        <div className="conferencia-stat-card">
          <div className="stat-header">
            <i className="fas fa-exclamation-triangle" style={{ color: '#e74c3c' }}></i>
            <span>Divergências</span>
          </div>
          <p className="stat-value">{estatisticas.total_divergencias}</p>
          <p className="stat-sub" style={{ color: '#e74c3c' }}>{estatisticas.divergentes} conferências</p>
        </div>
      </div>

      {/* Por tipo */}
      <div className="tipo-grid">
        <div className="tipo-card amber">
          <i className="fas fa-box" style={{ color: '#e65100' }}></i>
          <p className="tipo-value" style={{ color: '#e65100' }}>{estatisticas.pre_carregamentos}</p>
          <p className="tipo-label" style={{ color: '#e65100' }}>Pré-Carregamento</p>
        </div>
        <div className="tipo-card blue">
          <i className="fas fa-truck" style={{ color: '#1565c0' }}></i>
          <p className="tipo-value" style={{ color: '#1565c0' }}>{estatisticas.carregamentos}</p>
          <p className="tipo-label" style={{ color: '#1565c0' }}>Carregamento</p>
        </div>
        <div className="tipo-card green">
          <i className="fas fa-arrow-down" style={{ color: '#2e7d32' }}></i>
          <p className="tipo-value" style={{ color: '#2e7d32' }}>{estatisticas.descarregamentos}</p>
          <p className="tipo-label" style={{ color: '#2e7d32' }}>Descarregamento</p>
        </div>
      </div>

      {/* Detalhes */}
      <div className="detalhes-grid">
        {/* Leituras por resultado */}
        <div className="card">
          <div className="card-header">
            <h2><i className="fas fa-barcode" style={{ marginRight: 8, color: '#8e44ad' }}></i> Resumo de Leituras</h2>
          </div>
          <div className="card-body">
            <div className="resumo-item">
              <span className="resumo-label"><i className="fas fa-check-circle" style={{ color: '#27ae60' }}></i> OK</span>
              <span className="resumo-valor" style={{ color: '#27ae60' }}>{leituras.ok}</span>
            </div>
            <div className="resumo-item">
              <span className="resumo-label"><i className="fas fa-exclamation-triangle" style={{ color: '#f39c12' }}></i> Duplicados</span>
              <span className="resumo-valor" style={{ color: '#f39c12' }}>{leituras.duplicados}</span>
            </div>
            <div className="resumo-item">
              <span className="resumo-label"><i className="fas fa-exclamation-triangle" style={{ color: '#e74c3c' }}></i> Não encontrados</span>
              <span className="resumo-valor" style={{ color: '#e74c3c' }}>{leituras.nao_encontrados}</span>
            </div>
          </div>
        </div>

        {/* Sessões */}
        <div className="card">
          <div className="card-header">
            <h2><i className="fas fa-mobile-alt" style={{ marginRight: 8, color: '#3498db' }}></i> Sessões Recentes</h2>
          </div>
          <div>
            {sessoes.length === 0 ? (
              <div style={{ padding: 16, fontSize: '0.85rem', color: '#7f8c8d' }}>Nenhuma sessão registrada</div>
            ) : (
              sessoes.map((sessao: any, idx: number) => (
                <div key={idx} className="sessao-item" style={{ borderBottom: '1px solid #ecf0f1' }}>
                  <div>
                    <p style={{ margin: 0, fontSize: '0.85rem' }}>
                      {new Date(sessao.login_em).toLocaleDateString('pt-BR')}{' '}
                      {new Date(sessao.login_em).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                    </p>
                    {sessao.dispositivo_info?.platform && (
                      <p style={{ margin: 0, fontSize: '0.75rem', color: '#7f8c8d' }}>{sessao.dispositivo_info.platform}</p>
                    )}
                  </div>
                  <span className={`status-badge ${sessao.logout_em ? 'status-inactive' : 'status-active'}`}>
                    {sessao.logout_em ? 'Encerrada' : 'Ativa'}
                  </span>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {/* Leituras por dia */}
      {leituras_por_dia.length > 0 && (
        <div className="card" style={{ marginBottom: 20 }}>
          <div className="card-header">
            <h2><i className="fas fa-calendar-alt" style={{ marginRight: 8, color: '#3498db' }}></i> Leituras por Dia</h2>
          </div>
          <div className="data-table-wrapper">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Data</th>
                  <th style={{ textAlign: 'center' }}>Total</th>
                </tr>
              </thead>
              <tbody>
                {leituras_por_dia.map((dia: any) => (
                  <tr key={dia.data}>
                    <td style={{ fontWeight: 500 }}>{new Date(dia.data).toLocaleDateString('pt-BR')}</td>
                    <td style={{ textAlign: 'center', fontWeight: 600 }}>{dia.total}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Últimas conferências */}
      {ultimas_conferencias.length > 0 && (
        <div className="card">
          <div className="card-header">
            <h2><i className="fas fa-box-open" style={{ marginRight: 8, color: '#27ae60' }}></i> Últimas Conferências</h2>
          </div>
          <div className="data-table-wrapper">
            <table className="data-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Tipo</th>
                  <th>Veículo</th>
                  <th style={{ textAlign: 'center' }}>Itens</th>
                  <th style={{ textAlign: 'center' }}>Diverg.</th>
                  <th style={{ textAlign: 'center' }}>Status</th>
                  <th>Data</th>
                </tr>
              </thead>
              <tbody>
                {ultimas_conferencias.map((conf: any) => {
                  const tipoInfo = TIPO_LABELS[conf.tipo] || { label: conf.tipo, color: '#7f8c8d' };
                  return (
                    <tr key={conf.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/conferencia/${conf.id}`)}>
                      <td style={{ fontWeight: 500 }}>#{conf.id}</td>
                      <td style={{ color: tipoInfo.color }}>{tipoInfo.label}</td>
                      <td style={{ color: '#7f8c8d' }}>{conf.placa_veiculo || '-'}</td>
                      <td style={{ textAlign: 'center' }}>{conf.total_itens_conferido}/{conf.total_itens_esperado}</td>
                      <td style={{ textAlign: 'center' }}>
                        <span style={{ color: conf.total_divergencias > 0 ? '#e74c3c' : '#7f8c8d' }}>{conf.total_divergencias}</span>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <span className={`status-badge ${STATUS_COLORS[conf.status] || 'status-inactive'}`}>{STATUS_LABELS[conf.status] || conf.status}</span>
                      </td>
                      <td style={{ color: '#7f8c8d' }}>{new Date(conf.criado_em).toLocaleDateString('pt-BR')}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConferenciaProdutividadeDetalhe;
